var uncurryThis = require('../internals/function-uncurry-this');

module.exports = uncurryThis([].slice);



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/array-slice.js